import React from 'react';

const MainWrapper = ({children}) => {
  return <div className="container">{children}</div>;
};

export default MainWrapper;
